module.exports = __webpack_public_path__ + "img/SKMA_SHE.1da763b7.jpg";